var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
    fill: "#FF6969",
    stroke: "#FF6969",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.472 7.528a.523.523 0 0 1 0 .74l-6.205 6.204a.522.522 0 0 1-.739 0l6.944-6.944zm0 0a.523.523 0 0 0-.74 0m.74 0h-.74m0 0-6.204 6.205m6.205-6.205-6.205 6.205m0 0a.523.523 0 0 0 0 .739v-.74z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.472 13.733a.523.523 0 0 1 0 .739.522.522 0 0 1-.74 0L7.529 8.267a.523.523 0 0 1 0-.739m6.944 6.205L8.09 7.705a.273.273 0 0 0-.385 0l-.177-.177m6.944 6.205L8.267 7.528l-.176.177.176-.177m6.205 6.205L8.267 7.528m-.739 0a.523.523 0 0 1 .74 0m-.74 0h.74",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/iconError.331fd860fcd2d5ef85fbe5a39320edb2.svg";
export { ForwardRef as ReactComponent };